module.exports = __webpack_public_path__ + "img/stock6.283e493f.png";